import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NODE_20 } from '@app/@core/constants/common.constants';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class PingService {
  private urlBase: string;
  constructor(private _http: HttpClient) {}

  getCheckStatus(node: string): Observable<boolean> {
    let encriptado =
      node === NODE_20 ? environment.URL_BASE_IP_AUTHENTICATION_20 : environment.URL_BASE_IP_AUTHENTICATION_21;
    let bytes = CryptoJS.AES.decrypt(encriptado, environment.key);
    this.urlBase = bytes.toString(CryptoJS.enc.Utf8);
    return this._http.post<boolean>(this.urlBase + environment.subUrlcheckStatus, null);
  }
}
